var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGermany({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.746384 16.1739C2.4419 20.7434 6.84041 24 12 24C17.1596 24 21.5581 20.7434 23.2536 16.1739L12 15.1304L0.746384 16.1739Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C6.84041 0 2.4419 3.2565 0.746384 7.82611L12 8.86955L23.2536 7.82606C21.5581 3.2565 17.1596 0 12 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.746391 7.82611C0.264047 9.1261 0 10.5322 0 12C0 13.4678 0.264047 14.8739 0.746391 16.1739H23.2537C23.736 14.8739 24 13.4678 24 12C24 10.5322 23.736 9.1261 23.2536 7.82611H0.746391Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/germany.21858e5d85a12a58e90ed37accbea430.svg";
export { ForwardRef as ReactComponent };